module.exports = __webpack_public_path__ + "static/media/CTLI_17-293w.dbf6f3c0.webp";